import { BehApiRoutes } from '../beh-api';
import type { Query } from '@tanstack/react-query';

export function matchesCaseOrAllCasesQueries(caseId: string) {
  return (query: Query) =>
    query.queryKey.some(
      (key) =>
        typeof key === 'string' &&
        (key.startsWith(BehApiRoutes.case(caseId)) ||
          key.includes(`${BehApiRoutes.allCases()}?page=`))
    );
}
